import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { CheckText } from '../../../components/common/CheckText';
import Spinner from '../../../components/common/Spinner';
import { H5, P1 } from '../../../styles/FontStyles';
import { Box, Button, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconWarningMark } from '../../../styles/Icons';
import { changeAutoStake } from '../Portfolio.actions';
import { UserPackage } from '../Portfolio.types';

interface AutoStakeProps {
  toggle: boolean;
  packageItem: UserPackage | null;
  setToggle: Dispatch<SetStateAction<boolean>>;
  setAutostake: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
}

export const AutoStake = ({
  packageItem,
  setToggle,
  toggle,
  setAutostake,
  isOpen
}: AutoStakeProps) => {
  const [state1, setState1] = useState(false);
  const [state2, setState2] = useState(false);

  const dispatch = useDispatch();

  const { loading: loadingAutoStake } = useAppSelector(
    (state) => state.portfolio
  );

  const { t } = useTranslation('my_hubs');

  useEffect(() => {
    setState1(false);
    setState2(false);
  }, [isOpen]);

  if (loadingAutoStake) return <Spinner solid={false} />;

  return (
    <>
      <Box blue>
        <Flexed column center>
          <Icon mb='12'>
            <IconWarningMark size='50' />
          </Icon>
          <H5 mb='20' center color={color.colors.neutral500}>
            {t('auto_stake_modal.warning')}
          </H5>
          <P1 mb='20' center bold>
            {t('auto_stake_modal.text1')}{' '}
            <span> {t('auto_stake_modal.drastically_impact')} </span>{' '}
            {t('auto_stake_modal.your_ranking')}.
            <br />
            <br />
            {t('auto_stake_modal.risk')}:
          </P1>

          <Flexed column>
            <CheckText x text={t('auto_stake_modal.check1')} />
            <CheckText x text={t('auto_stake_modal.check2')} />
            <CheckText x text={t('auto_stake_modal.check3')} />
            <CheckText x text={t('auto_stake_modal.check4')} />
          </Flexed>
        </Flexed>
      </Box>

      <CheckText
        checked={state1}
        onClick={() => setState1(!state1)}
        text={t('auto_stake_modal.check5')}
      />
      <CheckText
        checked={state2}
        onClick={() => setState2(!state2)}
        text={t('auto_stake_modal.check6')}
      />

      <Button mt='20' onClick={() => setAutostake(false)}>
        {t('auto_stake_modal.keep')}
      </Button>
      <Button
        textButton
        disabled={!state1 || !state2}
        onClick={() =>
          dispatch(
            changeAutoStake({
              userPackageId: packageItem!.id,
              newStatus: false,
              setAutostake,
              toggle,
              setToggle
            })
          )
        }>
        {t('auto_stake_modal.put_off')}
      </Button>
    </>
  );
};
